<script>
  import { onMount, onDestroy } from 'svelte'
  import { tweened, spring } from 'svelte/motion'
  import { cubicOut } from 'svelte/easing'
  import { random, randomHex } from '../utils'

  let speed = 4000
  let springConfig = {
    stiffness: 0.03,
    damping: 0.98,
    easing: cubicOut,
  }

  let size = spring(0.01, springConfig)
  let color = spring({ h: 0, s: 0, l: 0 }, springConfig)
  let strokeWidth = spring(40, springConfig)

  const randomize = async () => {
    strokeWidth.damping = random(24, 160) / 100
    color.set({
      h: random(Math.min(1, $color.h), Math.max(360, $color.h)),
      s: random(Math.min(0, $color.s), Math.max(100, $color.s)),
      l: random(Math.min(0, $color.l), Math.max(100, $color.l)),
    })
    strokeWidth.set(random(4, 128) / 4)
    size.set(Math.min(window.innerWidth, window.innerHeight))
  }

  let interval = setInterval(randomize, speed)
</script>

<svg viewBox="-10 -10 160 160" width={Math.abs($size)} height={Math.abs($size)}>
  <defs>
    <linearGradient
      x1="46.057%"
      y1="23.699%"
      x2="50%"
      y2="100%"
      id="logo_svg__a">
      <stop stop-color="#F5F5F5" offset="0%" />
      <stop stop-color="#484848" stop-opacity="0.77" offset="77.6576048%" />
      <stop stop-color="#484848" stop-opacity="0.190783514" offset="100%" />
    </linearGradient>
  </defs>
  <path
    id="cube-fill"
    transform="rotate(5 -36.778 187.642)"
    d="M61.339 10.644l48.497 28v56l-48.497 28-48.498-28v-56z"
    fill={'hsl(' + $color.h + ',' + $color.s + '%,' + $color.l + '%)'}
    stroke="url(#logo_svg__a)"
    stroke-width={Math.abs($strokeWidth)}
    fill-rule="evenodd" />
</svg>
